import { StaffActivitiesByDescription } from "../../types";

const statePortalMeasure = (staffInputs: {
  fees: boolean;
  documentTypes: {
    invoice: boolean;
    receipt: boolean;
    report: boolean;
  };
}) => {
  return {
    parameters: {
      linkUrls: ["https://westvirginia.hazconnect.com/Account/Login.aspx"],
      staffInputs,
    },
    jurisdictionType: "State" as const,
    activityType: "Portal" as const,
    state: "WV" as const,
  };
};

export const staffActivities: StaffActivitiesByDescription = {
  "West Virginia Invoice": {
    parameters: {
      linkUrls: ["https://westvirginia.hazconnect.com/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Credential",
    state: "WV",
  },
  "West Virginia State Portal": statePortalMeasure({
    fees: false,
    documentTypes: {
      invoice: false,
      receipt: false,
      report: true,
    },
  }),
  "West Virginia State Portal - Oil and Gas": statePortalMeasure({
    fees: false,
    documentTypes: {
      invoice: false,
      receipt: false,
      report: true,
    },
  }),
  "West Virginia Portal Newly Not Reporting": {
    parameters: {
      staffInputs: {
        documentTypes: {
          proof: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "WV",
  },
};
